<template>
  <div v-show="false" />
</template>

<script>
import {
  defineComponent,
  useMeta,
  ref,
  useRoute,
} from '@nuxtjs/composition-api';
import { useI18n } from '~/helpers/hooks/usei18n';

export default defineComponent({
  name: 'StructuredBreadcrumbData',
  head: {},
  props: {
    path: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const route = useRoute();
    const { locale } = useI18n();
    const pathSplitted =
      props.path === ''
        ? route.value.params.path.split('/')
        : props.path.split('/');
    const pathToBreadcrumbCategory = ref(
      `https://www.sognidicristallo.com/${locale}/`
    );
    // Creating bradcrumbs data splitting url by / and then composing it step-by-step with the splitted elements
    const structuredBreadcrumbData = ref({
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [],
    });

    pathSplitted.forEach((element, index) => {
      pathToBreadcrumbCategory.value += `${element}`;
      structuredBreadcrumbData.value.itemListElement.push({
        '@type': 'ListItem',
        position: index + 1,
        name: `${element.charAt(0).toUpperCase()}${element.slice(1)}`,
        item: pathToBreadcrumbCategory.value,
      });
      pathToBreadcrumbCategory.value += '/';
    });

    useMeta(() => ({
      script: [
        {
          innerHTML: JSON.stringify(structuredBreadcrumbData.value),
          type: 'application/ld+json',
        },
      ],
      __dangerouslyDisableSanitizers: ['script'],
    }));
  },
});
</script>
